import * as React from 'react';
import { DriverIcon } from 'src/app/components/Icons';
import { DRIVER, DRIVER_DASHBOARD, DRIVER_FEE, DRIVER_SALARY, PENALTY } from 'src/app/constants/route';
import { SidebarItem } from '../sidebar';

const DRIVER_SCHEDULE_SIDEBAR: SidebarItem = {
  authorityIds: [DRIVER.requiredAuthority!],
  iconName: 'ic-driverSchedule',
  id: 'driverSchedule',
  labelId: 'sidebar.driverSchedule',
  url: DRIVER.path
};

const DRIVER_FEE_SIDEBAR: SidebarItem = {
  authorityIds: [DRIVER_FEE.requiredAuthority!],
  iconName: 'ic-driverFee',
  id: 'driverFee',
  labelId: 'sidebar.driverFee',
  url: DRIVER_FEE.path
};

const DRIVER_DASHBOARD_SIDEBAR: SidebarItem = {
  authorityIds: [DRIVER_DASHBOARD.requiredAuthority!],
  iconName: 'ic-driverDashboard',
  id: 'driverDashboard',
  labelId: 'sidebar.driverDashboard',
  url: DRIVER_DASHBOARD.path
};

const DRIVER_SALARY_SIDEBAR: SidebarItem = {
  authorityIds: [DRIVER_FEE.requiredAuthority!],
  iconName: 'ic-driverSalary',
  id: 'driverSalary',
  labelId: 'sidebar.driverSalary',
  url: DRIVER_SALARY.path
};

const DRIVER_PENALTY_SIDEBAR: SidebarItem = {
  authorityIds: [PENALTY.requiredAuthority!],
  iconName: 'ic-driverPenalty',
  id: 'driverPenalty',
  labelId: 'sidebar.penalty',
  url: PENALTY.path
}

export const DRIVER_SIDEBAR: SidebarItem = {
  authorityIds: [DRIVER.requiredAuthority!, DRIVER_FEE.requiredAuthority!, DRIVER_DASHBOARD.requiredAuthority!, PENALTY.requiredAuthority!],
  children: [DRIVER_SCHEDULE_SIDEBAR, DRIVER_FEE_SIDEBAR, DRIVER_DASHBOARD_SIDEBAR, DRIVER_SALARY_SIDEBAR, DRIVER_PENALTY_SIDEBAR],
  icon: <DriverIcon />,
  iconName: 'ic-driver',
  id: 'driver',
  labelId: 'sidebar.driver'
};
